import { Button, Card, Group, Stack, Text } from '@mantine/core'
import { IconCalendar, IconVideo } from '@tabler/icons-react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/parents-evening/')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <div className={'p-5 justify-start flex flex-col items-center'}>
            <Stack>
                <Text size={'2rem'} fw={700} mb={'md'}>Parents' Evenings at Godalming College</Text>
                <Text size={'1rem'} c={'dimmed'}>We host Parents' Evenings right here on the Parent Portal. When bookings open, you will be able to schedule appointments with your child's teachers on this page.</Text>
            </Stack>
            <Group mt={'xl'}>
                <Card shadow="sm" padding="md" radius="md" withBorder >
                    <Card.Section withBorder inheritPadding py={'xs'}>
                        <Text fw={500} c={'dimmed'} size='sm'>Book appointments</Text>
                    </Card.Section>
                    <Card.Section inheritPadding py={'xs'}>
                        <Text size='sm' mb={'md'} c={'dimmed'}>Bookings are not open</Text>
                        <Button disabled leftSection={<IconCalendar />}>Book appointments</Button>
                    </Card.Section>
                </Card>
                <Card shadow="sm" padding="md" radius="md" withBorder >
                    <Card.Section withBorder inheritPadding py={'xs'}>
                        <Text fw={500} c={'dimmed'} size='sm'>Attend appointments</Text>
                    </Card.Section>
                    <Card.Section inheritPadding py={'xs'}>
                        <Button leftSection={<IconVideo />}>Join now</Button>
                    </Card.Section>
                </Card>
            </Group>
        </div>
    )
}
